
	import Vue from 'vue';
	import {Component, Prop} from 'vue-property-decorator';
	import {IItem} from "@/models/IItem";

	@Component
	export default class ItemChipLinkRustlabs extends Vue {

		@Prop({type: Object, required: true})
		public item!: IItem;

		@Prop({type: Boolean, default: false})
		public dense!: boolean;

		@Prop({type: Boolean, default: false})
		public small!: boolean;

		@Prop({type: Boolean, default: false})
		public xSmall!: boolean;

		@Prop({type: String, default: 'yellow'})
		public color!: string;

		private get label(): string {
			return this.dense ? 'R' : 'Rustlabs';
		}

		private openLink(): void {
			if (this.item.rustlabs_url === null) return;
			window.open(this.item.rustlabs_url, '_blank');
		}

	}
